<template>
  <div
    class="flex flex-1 flex-col h-full bg-neutral-lightest pb-2 support-portal-langing"
    :class="{ '-mb-8': chatConfigContext.config.enabled }"
  >
    <!-- <div class="flex flex-col support-portal-banner-container"> -->
    <div
      class="flex flex-col support-portal-banner"
      :style="{
        backgroundImage: branding.supportPortalBackgroundSrc
          ? `url(${branding.supportPortalBackgroundSrc})`
          : `url(/images/support-portal-banner.png)`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }"
    >
      <div
        class="flex flex-col items-enter justify-center pb-6 items-center w-full"
      >
        <div class="w-3/2 flex flex-col items-enter justify-center">
          <div class="welcome-message" v-html="branding.greetingMessage">
            {{ branding.greetingMessage }}
          </div>
          <div v-if="allowRequesterToAccessKB" class="search-title">
            {{ $tc('search_our_support_center_kb') }}
          </div>
        </div>
        <div
          class="flex flex-col items-enter justify-center items-center"
          style="width: 30%"
        >
          <MInput
            v-if="allowRequesterToAccessKB"
            v-model="searchTerm"
            size="large"
            auto-focus
            :placeholder="__t('how_can_we_help_you')"
            class="kb-search-input shadow rounded"
            style="min-width: 350px"
            @enterKey="searchKb"
          >
            <template v-slot:prefix>
              <MIcon name="search" />
            </template>
          </MInput>
        </div>
      </div>
      <div class="flex justify-center items-center flex-wrap">
        <FlotoLink
          v-if="isAllowedCreateIncident"
          :to="$currentModule.getRoute('create-request')"
        >
          <div class="quick-action-box create-incident">
            <div class="flex flex-1 items-center">
              <div class="icon-container">
                <MIcon name="ticket-alt" size="3x" />
              </div>
              <div class="action-container">
                <div class="action-title">{{ $tc('new_incident') }}</div>
                <div class="action-sub-title">{{
                  $tc('new_incident_tag_line')
                }}</div>
              </div>
            </div>
            <div class="flex action">
              <MIcon name="arrow-right" size="2x" />
            </div>
          </div>
        </FlotoLink>
        <FlotoLink
          v-if="isAllowedRequestForService"
          :to="$currentModule.getRoute('service-list')"
        >
          <div class="quick-action-box request-service">
            <div class="flex flex-1 items-center">
              <div class="icon-container">
                <MIcon name="shopping-cart" size="2x" />
              </div>
              <div class="action-container">
                <div class="action-title">{{ $tc('request_service') }}</div>
                <div class="action-sub-title"
                  >{{ $tc('request_service_tag_line') }}
                </div>
              </div>
            </div>
            <div class="flex action">
              <MIcon name="arrow-right" size="2x" />
            </div>
          </div>
        </FlotoLink>
        <FlotoLink
          v-if="!loggedIn && selfServiceSetting"
          :to="$currentModule.getRoute('self-service')"
        >
          <div class="quick-action-box knowledge">
            <div class="flex flex-1 items-center">
              <div class="icon-container">
                <MIcon name="ad-self-service" size="3x" />
              </div>
              <div class="action-container">
                <div class="action-title"> {{ $tc('ad_self_service') }} </div>
                <div class="action-sub-title">
                  {{ $tc('reset_your_password') }}
                </div>
              </div>
            </div>
            <div class="flex action">
              <MIcon name="arrow-right" size="2x" />
            </div>
          </div>
        </FlotoLink>
        <FlotoLink
          v-if="allowRequesterToAccessKB"
          :to="$currentModule.getRoute('all-articles')"
        >
          <div class="quick-action-box knowledge">
            <div class="flex flex-1 items-center">
              <div class="icon-container">
                <MIcon name="knowledge" size="3x" />
              </div>
              <div class="action-container">
                <div class="action-title">{{ $tc('knowledge') }}</div>
                <div class="action-sub-title">{{
                  $tc('knowledge_tag_line')
                }}</div>
              </div>
            </div>
            <div class="flex action">
              <MIcon name="arrow-right" size="2x" />
            </div>
          </div>
        </FlotoLink>
      </div>
      <!-- <img
        class="background-image"
        :src="branding.supportPortalBackgroundSrc"
      /> -->
    </div>
    <!-- </div> -->
    <div class="flex flex-col flex-1 px-2">
      <MRow>
        <MCol v-if="displaySecurityPopup && selfServiceSetting" :size="12">
          <MAlert type="info" banner closable @close="handleAlertClose">
            <a>
              <SecurityQuestionAnswerDrawer @refresh="getUserProfile">
                <template v-slot:trigger>
                  {{ $tc('configure_security_question_answer') }}
                </template>
              </SecurityQuestionAnswerDrawer>
            </a>
          </MAlert>
        </MCol>
      </MRow>
      <MRow :gutter="0" class="flex flex-1 flex-col w-full">
        <MCol class="flex flex-col flex-1" :size="12">
          <MRow :gutter="8" class="mt-2">
            <!-- announcements.length > 0 ? 9 : 12 -->
            <MCol
              v-if="loggedIn"
              class="flex flex-col mb-2"
              :xxl="9"
              :xl="9"
              :lg="9"
              :sm="12"
              :xsm="12"
            >
              <MRow
                v-if="
                  loggedIn &&
                  hasServiceCatalog &&
                  allowRequesterToAccessServiceRequest &&
                  favoriteServiceCalatog.length
                "
                :gutter="8"
              >
                <MCol
                  v-for="service in favoriteServiceCalatog"
                  :key="service.id"
                  class="flex mb-3"
                  :style="{ width: serviceCatalogWidth }"
                >
                  <FlotoLink
                    :to="
                      $modules.getModuleRoute(
                        'support-portal',
                        'request-service',
                        {
                          params: { id: service.id },
                        }
                      )
                    "
                    class="w-full"
                  >
                    <div class="box box-style text-center">
                      <img
                        :src="service.image"
                        height="35"
                        width="35"
                        class="mb-4"
                      />
                      <MTooltip>
                        <template v-slot:trigger>
                          <div class="service-name text-ellipsis w-full px-2">
                            {{ service.name }}
                          </div>
                        </template>
                        {{ service.name }}
                      </MTooltip>
                      <div class="service-category text-ellipsis w-full px-2">
                        {{ serviceCategoryName(service.categoryId) }}
                      </div>
                    </div>
                  </FlotoLink>
                </MCol>
              </MRow>
              <MRow
                v-if="hasRequestModule || allowRequesterToAccessMyApprovals"
                :gutter="0"
              >
                <MCol class="flex flex-1 mb-2 min-w-0">
                  <div class="box-style flex flex-1 min-w-0">
                    <div v-if="hasRequestModule" class="list-container">
                      <MyOpenRequests />
                    </div>
                    <div
                      v-if="allowRequesterToAccessMyApprovals"
                      class="list-container"
                    >
                      <PendingApprovals />
                    </div>
                  </div>
                </MCol>
              </MRow>
              <MRow v-if="loggedIn" :gutter="8">
                <MCol
                  v-if="hasMyAssetModule"
                  :xxl="7"
                  :xl="7"
                  :lg="7"
                  :sm="12"
                  :xsm="12"
                  class="flex-grow"
                >
                  <div class="box-style flex flex-1 h-full">
                    <div class="list-container less-pedding">
                      <MyAssetsCard />
                    </div>
                  </div>
                </MCol>
                <MCol
                  v-if="hasMyCiModule"
                  :xxl="7"
                  :xl="7"
                  :lg="7"
                  :sm="12"
                  :xsm="12"
                  class="flex-grow"
                >
                  <div class="box-style flex flex-1 h-full">
                    <div class="list-container less-pedding">
                      <MyAssetsCard :module-name="$constants.CMDB" />
                    </div>
                  </div>
                </MCol>
                <!-- :size="hasMyAssetModule ? '5' : '12'" -->
                <!-- <MCol :xxl="5" :xl="5" :lg="5" :sm="12" :xsm="12">
                  <div class="box-style flex flex-1 h-full">
                    <div class="list-container less-pedding">
                      <FeedbackCard />
                    </div>
                  </div>
                </MCol> -->
              </MRow>
            </MCol>
            <!-- :size="3" -->
            <MCol
              v-if="
                announcements.length > 0 ||
                mostReadArticles.length > 0 ||
                branding.email ||
                branding.contactNumber
              "
              class="flex mb-2"
              :xxl="3"
              :xl="3"
              :lg="3"
              :sm="12"
              :xsm="12"
            >
              <div class="box-style flex-1 min-w-0">
                <div class="list-container flex flex-1 flex-col h-full">
                  <div
                    v-if="announcements.length > 0"
                    class="flex flex-1 h-full mb-2"
                  >
                    <AnnouncementCard
                      :view-all-link="$currentModule.getRoute('announcements')"
                      :announcements="announcements"
                    />
                  </div>
                  <div
                    v-if="mostReadArticles.length > 0"
                    class="flex flex-1 h-full mb-2"
                  >
                    <MostReadCard
                      :view-all-link="$currentModule.getRoute('all-articles')"
                      :most-read-articles="mostReadArticles"
                    />
                  </div>
                  <div
                    v-if="branding.email || branding.contactNumber"
                    class="flex flex-1 h-full mb-2"
                  >
                    <ContactUsCard />
                  </div>
                </div>
              </div>
            </MCol>
          </MRow>
        </MCol>
      </MRow>
      <!-- <MRow :gutter="0" class="flex flex-1 flex-col w-full">
        <MCol class="flex flex-col flex-1">
          <MRow :gutter="8" class="mt-2 flex flex-1">
            <MCol
              class="flex flex-col"
              :size="announcements.length > 0 ? 8 : 12"
            >
              <MRow :gutter="8">
                <MCol v-if="hasRequestModule">
                  <div class="box">
                    <RequestImage />
                    <span class="h-12 mt-2 font-semibold">
                      {{ $tc('request') }}
                    </span>
                    <FlotoLink :to="$currentModule.getRoute('my-requests')">
                      {{ $tc('my_request') }} <MIcon :name="linkArrowIcon" />
                    </FlotoLink>
                  </div>
                </MCol>
                <MCol v-if="hasRequestModule">
                  <div class="box">
                    <CreateIncidentImage />
                    <span class="h-12 mt-2 font-semibold">
                      {{ $tc('incident') }}
                    </span>
                    <FlotoLink :to="$currentModule.getRoute('create-request')">
                      {{ $tc('create') }} {{ $tc('incident') }}
                      <MIcon :name="linkArrowIcon" />
                    </FlotoLink>
                  </div>
                </MCol>
                <MCol
                  v-if="
                    loggedIn &&
                    allowRequesterToAccessMyApprovals &&
                    (hasRequestModule || hasAssetModule)
                  "
                >
                  <div class="box">
                    <ApprovalImage />
                    <span class="h-12 mt-2 font-semibold">
                      {{ $tc('my_approvals') }}
                    </span>
                    <FlotoLink :to="$currentModule.getRoute('my-approvals')">
                      {{ $tc('view') }} {{ $tc('all') }}
                      <MIcon :name="linkArrowIcon" />
                    </FlotoLink>
                  </div>
                </MCol>
                <MCol
                  v-if="
                    loggedIn &&
                    hasServiceCatalog &&
                    allowRequesterToAccessServiceRequest
                  "
                >
                  <div class="box">
                    <ServiceRequestImage />
                    <span class="h-12 mt-2 font-semibold">
                      {{ $tc('request') }} {{ $tc('service') }}
                    </span>
                    <FlotoLink :to="$currentModule.getRoute('service-list')">
                      {{ $tc('create') }} {{ $tc('request') }}
                      <MIcon :name="linkArrowIcon" />
                    </FlotoLink>
                  </div>
                </MCol>
                <MCol v-if="!loggedIn && selfServiceSetting">
                  <div class="box">
                    <div class="icon-custom-bg">
                      <SelfServiceImage />
                    </div>
                    <span class="h-12 mt-2 font-semibold">
                      {{ $tc('active_directory_self_service') }}
                    </span>
                    <FlotoLink :to="$currentModule.getRoute('self-service')">
                      {{ $tc('view') }} <MIcon :name="linkArrowIcon" />
                    </FlotoLink>
                  </div>
                </MCol>
                <MCol v-if="allowRequesterToAccessKB">
                  <div class="box">
                    <KnowledgeImage />
                    <span class="h-12 mt-2 font-semibold">
                      {{ $tc('knowledge') }}
                    </span>
                    <FlotoLink :to="$currentModule.getRoute('all-articles')">
                      {{ $tc('explore') }} {{ $tc('all') }}
                      <MIcon :name="linkArrowIcon" />
                    </FlotoLink>
                  </div>
                </MCol>
              </MRow>
              <MRow
                v-if="allowRequesterToAccessKB && mostReadArticles.length"
                :gutter="8"
                class="flex flex-1"
              >
                <MCol class="flex flex-1">
                  <div class="most-read-kb flex flex-1">
                    <h5 class="font-semibold text-primary-alt mb-2">
                      {{ $t('most_read') }}
                    </h5>
                    <div class="flex flex-col">
                      <div
                        v-for="article in mostReadArticles"
                        :key="article.id"
                        class="text-ellipsis mb-2"
                      >
                        <FlotoLink
                          :to="
                            $currentModule.getRoute('read', {
                              params: { id: article.id },
                            })
                          "
                        >
                          <span>
                            {{ article.name }}: {{ article.subject }}
                          </span>
                        </FlotoLink>
                      </div>
                    </div>
                  </div>
                </MCol>
              </MRow>
            </MCol>
            <MCol v-if="announcements.length > 0" :size="4">
              <AnnouncementBanner
                :view-all-link="$currentModule.getRoute('announcements')"
                class="h-full shadow rounded"
                vertical
                :announcements="announcements"
              />
            </MCol>
          </MRow>
        </MCol>
      </MRow> -->
    </div>
  </div>
</template>

<script>
import { authComputed, authMethods } from '@state/modules/auth'
import { BrandingComputed } from '@state/modules/branding'
import { LicenseComputed } from '@state/modules/license'
import { SupportPortalConfigComputed } from '@state/modules/support-portal-config'
import {
  getUserProfileApi,
  updateUserProfileApi,
} from '@state/modules/auth/api'
// import AnnouncementBanner from '@components/announcement/announcement-banner'
// import RequestImage from '../graphics/request.svg'
// import ApprovalImage from '../graphics/approval.svg'
// import ServiceRequestImage from '../graphics/request-service.svg'
// import KnowledgeImage from '../graphics/knowledge.svg'
// import SelfServiceImage from '../graphics/self-service.svg'
// import CreateIncidentImage from '../graphics/create-incident.svg'
import { PreferenceComputed } from '@state/modules/preference'
import { knowledgeAnalyticsApi } from '../../knowledge/knowledge-api'
import { getAnnouncementForRequesterApi } from '../../organization/announcement-api'
import SecurityQuestionAnswerDrawer from '@components/layout/profile/security-question-answer-drawer'
import { getServiceCatalogsApi } from '@modules/service-catalog/service-catalog-api'
import { CategoryComputed } from '@state/modules/category'
import MyOpenRequests from '../components/landing-page/my-open-requests.vue'
import PendingApprovals from '../components/landing-page/pending-approvals.vue'
import MyAssetsCard from '../components/landing-page/my-assets-card.vue'
// import FeedbackCard from '../components/landing-page/feedback-card.vue'
import AnnouncementCard from '../components/landing-page/announcement-card.vue'
import MostReadCard from '../components/landing-page/most-read-card.vue'
import ContactUsCard from '../components/landing-page/contact-us-card.vue'

export default {
  name: 'Landing',
  components: {
    // RequestImage,
    // CreateIncidentImage,
    // ApprovalImage,
    // ServiceRequestImage,
    // KnowledgeImage,
    // SelfServiceImage,
    // AnnouncementBanner,
    SecurityQuestionAnswerDrawer,
    MyOpenRequests,
    PendingApprovals,
    MyAssetsCard,
    // FeedbackCard,
    AnnouncementCard,
    MostReadCard,
    ContactUsCard,
  },
  inject: { chatConfigContext: { config: {} } },
  data() {
    this.topServiceCatalogCount = 4
    return {
      mostReadArticles: [],
      searchTerm: '',
      announcements: [],
      displaySecurityPopup: false,
      favoriteServiceCalatog: [],
      serviceCatalogWidth: `${Math.round(100 / this.topServiceCatalogCount)}%`,
    }
  },
  computed: {
    ...BrandingComputed,
    ...authComputed,
    ...LicenseComputed,
    ...PreferenceComputed,
    ...SupportPortalConfigComputed,
    ...CategoryComputed,
    hasMyAssetModule() {
      return (
        this.allowReqToAccessMyAsset &&
        this.availableModulesInLicense.indexOf(this.$constants.ASSET) >= 0 &&
        this.myAllowedModules.indexOf(this.$constants.ASSET) >= 0
      )
    },
    hasMyCiModule() {
      return (
        this.allowReqToAccessMyCi &&
        this.availableModulesInLicense.indexOf(this.$constants.CMDB) >= 0 &&
        this.myAllowedModules.indexOf(this.$constants.CMDB) >= 0
      )
    },
    hasServiceCatalog() {
      return (
        this.availableModulesInLicense.indexOf(
          this.$constants.SERVICE_CATALOG
        ) >= 0
      )
    },
    hasRequestModule() {
      return (
        this.availableModulesInLicense.indexOf(this.$constants.REQUEST) >= 0
      )
    },
    hasAssetModule() {
      return this.availableModulesInLicense.indexOf(this.$constants.ASSET) >= 0
    },
    linkArrowIcon() {
      if (this.isRtl) {
        return 'long-arrow-left'
      }
      return 'long-arrow-right'
    },
    isAllowedCreateIncident() {
      if (this.hasRequestModule) {
        if (this.loggedIn && this.allowRequesterToCreateIncidents) {
          return true
        } else if (
          !this.loggedIn &&
          this.allowRequesterToCreateIncidents &&
          this.allowGuestToCreateIncident
        ) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    isAllowedRequestForService() {
      if (this.hasRequestModule) {
        if (
          this.loggedIn &&
          this.hasServiceCatalog &&
          this.allowRequesterToAccessServiceRequest
        ) {
          return true
        } else if (
          !this.loggedIn &&
          this.hasServiceCatalog &&
          this.allowGuestToRequestForService
        ) {
          return true
        } else {
          return false
        }
      }
      return false
    },
  },
  watch: {
    user() {
      this.getAnnouncements()
    },
    loggedIn() {
      this.getMostReadArticles()
    },
  },

  created() {
    this.getMostReadArticles()
    this.getAnnouncements()
    if (this.loggedIn) {
      this.getUserProfile()
      if (this.hasRequestModule) {
        this.getServices()
      }
    }
  },
  methods: {
    ...authMethods,
    searchKb() {
      this.$router.push(
        this.$currentModule.getRoute('all-articles', {
          params: { keyword: this.searchTerm },
        })
      )
    },
    getUserProfile() {
      getUserProfileApi().then((data) => {
        this.displaySecurityPopup = data.displaySecurityPopup
      })
    },
    handleAlertClose() {
      return updateUserProfileApi({ displaySecurityPopup: false })
    },
    getAnnouncements() {
      getAnnouncementForRequesterApi({}, 10, 0).then((data) => {
        this.announcements = data.items
      })
    },
    getMostReadArticles(limit, offset) {
      if (this.allowRequesterToAccessKB) {
        const params = {
          folderName: true,
          offset: offset || 0,
          size: 5,
        }
        knowledgeAnalyticsApi(true, params).then((data) => {
          this.mostReadArticles = data.mostRead
        })
      }
    },
    getServices() {
      const ids = this.favouriteItems(this.$constants.SERVICE_CATALOG)
      return getServiceCatalogsApi(
        {
          ids,
          isPublic: true,
          status: 'published',
        },
        this.topServiceCatalogCount,
        0
      ).then(({ items }) => {
        this.favoriteServiceCalatog = items
        this.serviceCatalogWidth = `${Math.round(100 / items.length)}%`
      })
    },
    serviceCategoryName(categoryId) {
      const category = this.serviceCatalogCategories.find(
        (c) => c.id === categoryId
      )
      return category ? category.name : '---'
    },
  },
}
</script>
<style lang="less" scoped>
// .most-read-kb {
//   @apply flex flex-col shadow p-3 rounded;

//   background: var(--page-background-color);
// }

// .icon-custom-bg {
//   @apply rounded;

//   width: 53px;
//   height: 53px;
//   padding: 10px;
//   color: var(--white-regular);
//   background: var(--primary);
// }

// .box {
//   @apply flex flex-col shadow mb-2;

//   min-width: 138px;
//   padding: 0.7rem !important;
//   background-color: var(--page-background-color);
//   border: 1px solid transparent;
//   transition: all 0.2s linear;

//   .action-button {
//     opacity: 0;
//     transition: opacity 0.2s linear;
//   }

//   @apply rounded;
//   // &:hover {
//   //   border-color: @neutral-lighter;

//   //   @apply shadow-lg;

//   //   .action-button {
//   //     opacity: 1;
//   //   }
//   // }
// }
</style>
<style lang="less" scoped>
.support-portal-langing {
  .kb-search-input {
    & input {
      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }

  .support-portal-banner {
    position: relative;
    min-height: 343px;
    overflow: hidden;

    // &::before {
    //   position: absolute;
    //   top: 0;
    //   right: 0;
    //   bottom: 0;
    //   left: 0;
    //   z-index: 1;
    //   content: '';
    //   background: linear-gradient(
    //     0deg,
    //     #06082a 32.97%,
    //     #07173e 38.94%,
    //     #0a3766 52.51%,
    //     #0c5188 66.62%,
    //     #0e66a2 80.73%,
    //     #0f74b5 95.38%,
    //     #107dc0 110.57%,
    //     #1180c4 127.12%,
    //     #188dc8 155.89%,
    //     #2bafd5 209.34%,
    //     #31b9d9 222.37%,
    //     #39c0a9 259.81%,
    //     #44ca6e 302.68%
    //   );
    //   opacity: 0.7;
    // }

    .background-image {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    @apply items-center justify-end pb-12 px-2;

    // position: absolute;
    // top: 0;
    // right: 0;
    // bottom: 0;
    // left: 0;
    // z-index: 2;
    // opacity: 1;

    & .welcome-message {
      @apply flex items-center justify-center text-white text-center;

      font-size: 2rem;
      font-weight: 500;
    }

    & .search-title {
      @apply flex items-center justify-center text-white mb-2 text-center;

      font-size: 1rem;
      font-weight: 300;
    }

    .quick-action-box {
      @apply flex items-center rounded justify-between text-white mx-2 mb-2;

      width: 18.313rem;
      padding: 1rem;

      & .action-container {
        @apply px-4;

        & .action-title {
          font-size: 0.938rem;
        }

        & .action-sub-title {
          font-size: 0.688rem;
        }
      }

      & .icon-container {
        @apply flex items-center justify-center rounded;

        width: 3.25rem;
        height: 3.25rem;
        background: rgba(255, 255, 255, 0.2);
      }

      &.create-incident {
        background: #0a5e8d;
        opacity: 0.9;
      }

      &.request-service {
        background: #0a6e8d;
        opacity: 0.9;
      }

      &.knowledge {
        background: #0a8d8d;
        opacity: 0.9;
      }
    }
  }

  .box {
    @apply flex flex-col flex-1 items-center justify-center;

    height: 155px;

    .service-name {
      font-size: 14px;
      font-weight: 500;
      color: var(--page-text-color);
    }

    .service-category {
      @apply text-neutral;

      font-size: 12px;
      font-weight: 400;
    }
  }

  .box-style {
    @apply rounded;

    background: var(--page-background-color);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .list-container {
    @apply flex flex-1 min-w-0;

    padding: 0.65rem 1.025rem;

    &.less-pedding {
      padding: 0.65rem 0.604rem !important;
    }
  }
}
</style>
